import { router } from "@/router";

export default {
  getToken() {
    return localStorage.getItem("token");
  },
};
